import { render, staticRenderFns } from "./OptionsTextAddBulk.vue?vue&type=template&id=64884e10&"
import script from "./OptionsTextAddBulk.vue?vue&type=script&lang=js&"
export * from "./OptionsTextAddBulk.vue?vue&type=script&lang=js&"
import style0 from "./OptionsTextAddBulk.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports